import React, { useContext } from 'react';
import { CryptodraftContext } from '../../../../contexts/card/cryptodraft/context';
import { currencies } from '../../../../utilities/constants';

const CryptodraftCurrenciesTabs = () => {
  const { state, updateSelectedWallet } = useContext(CryptodraftContext);

  const BTCWallet = state.allowedWallets.find((wallet) => wallet.coin === 'btc');
  const ETHWallet = state.allowedWallets.find((wallet) => wallet.coin === 'eth');

  return (
    <div className="flex-row-center bg-transparent border border-disabled rounded-4 my-3">
      <button
        className={`btn toggle-item bg-light ${
          state?.selectedWallet?.coin === BTCWallet?.coin ? 'active' : ''
        } py-2 rounded-4 flex-fill m-0`}
        type="button"
        disabled={!BTCWallet}
        onClick={() => updateSelectedWallet(BTCWallet)}>
        <b>{currencies.BTC.fullName}</b>
      </button>
      <button
        className={`btn m-0 toggle-item bg-light ${
          state?.selectedWallet?.coin === ETHWallet?.coin ? 'active' : 'bg-light'
        } py-2 rounded-4 flex-fill`}
        type="button"
        disabled={!ETHWallet}
        onClick={() => updateSelectedWallet(ETHWallet)}>
        <b>{currencies.ETH.fullName}</b>
      </button>
    </div>
  );
};

export default CryptodraftCurrenciesTabs;
